///? Default IMPORTS

import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

///? Service IMPORTS

import {
  pickerOrderDetailsThunk,
  saveMissingMedicineDetails,
  // clearPickerDetails,
} from "../../../redux/PickerOrder/Action";

import {
  getScannedPickerOrderDetailsThunk,
  // validateOrderAssignPickerThunk,
} from "../../../redux/NewPickerRedux/Action";

///? Component & Styling IMPORTS

import { OrderDetails } from "../../../components/OrderDetailSection/OrderDetails";
// import { decode as base64_decode } from "@faustbrian/node-base64-url";
import { Drawer, message, Result, Table, Tag } from "antd";
import OfflinePage from "../../OfflinePage/OfflinePage";
import { AiOutlineScan } from "react-icons/ai";
import {
  CheckerNotificationWrapper,
  OrderDetailsWrapper,
} from "./PickerProcess.styled";
import BarcodeScanner from "../../../components/BarcodeScanner/BarcodeScanner";
import { Base64func } from "../../../components/Base64Func/Base64func";
import { warehouseId } from "../../../constants";
import moment from "moment";

///? Constants

export class PickerOrderProcess extends Component {
  state = {
    currentOrderId: null,
    currentOrderData: null,
    checkerNotification: false,
    // pickerOnline: true,
    showScannerScreen: false,
    serviceLoading: false,
    reasonMaster: null,
    color: null,
    text: "",
  };
  componentDidMount() {
    message.loading("Loading", 0);

    // const storedSelectedOption =
    //   JSON.parse(localStorage.getItem("userOnline")) || false;
    // this.setState({ pickerOnline: storedSelectedOption });

    //? Getting order ID from url

    let currPath = window.location.href;

    let currPathArr = currPath.split("/");

    let orderValue = "";

    currPathArr.map((item) =>
      item.includes("orderId") ? (orderValue = item.split("=")[1]) : ""
    );

    var that = this;
    window.onpopstate = function (event) {
      that.props.history.push("/picker");
    };

    this.setState(
      {
        currentOrderId: Base64func(orderValue, "decode"),
        serviceLoading: true,
      },
      () => {
        message.destroy();
        //* Checker order update service here
        //* if we don't find any error there then this service below
        let data = {
          orderId: this.state.currentOrderId,
          warehouseId: warehouseId,
          access_token: this.props.access_token,
          history: this.props.history,
          isOrderAssigned: true,
        };

        this.props.getScannedPickerOrderDetailsThunk(data).then(() => {
          message.destroy();
          if (this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess) {
            if (
              this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess
                ?.missingMedicineDetails?.length > 0
            ) {
              // if (
              //   this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess
              //     .sdd
              // ) {
              //   this.setState({
              //     color: "green",
              //     text: "Hyperlocal",
              //   });
              // } else {
              //   if (
              //     this.props.newPickerDetails
              //       .newScannedPickerOrderDetailsSuccess.orderDate ===
              //     todayTimeStamp
              //   ) {
              //     this.setState({
              //       color: "yellow",
              //       text: "Today",
              //     });
              //   } else {
              //     this.setState({
              //       color: "red",
              //       text: "Past",
              //     });
              //   }
              // }
              this.setState({ checkerNotification: true });
            }
            this.tagger();
            this.setState({
              currentOrderData: this.props.newPickerDetails
                .newScannedPickerOrderDetailsSuccess,
              reasonMaster: this.props.newPickerDetails
                .newScannedPickerOrderDetailsSuccess.reasonMasterList,
              serviceLoading: false,
            });

            // this.props
            //   .validateOrderAssignPickerThunk({
            //     access_token: this.props.access_token,
            //     orderId: this.state.currentOrderId,
            //   })
            //   .then(() => {
            //     // if (this.props.newPickerDetails.validateOrderError) {
            //     //   message.error("Order is already assigned to a picker");
            //     //   this.props.history.goBack();
            //     // } else {

            //     this.setState({
            //       currentOrderData: this.props.newPickerDetails
            //         .newScannedPickerOrderDetailsSuccess,
            //       reasonMaster: this.props.newPickerDetails
            //         .newScannedPickerOrderDetailsSuccess.reasonMasterList,
            //       serviceLoading: false,
            //     });
            //     // }
            //   });
          } else if (this.props.newPickerDetails?.newScannedPickerOrderError) {
            message.error(
              this.props.newPickerDetails?.newScannedPickerOrderError
            );
            this.setState({ serviceLoading: false });
            this.props.history.goBack();
          }
        });
      }
    );
  }
  tagger = () => {
    let todayTimeStamp = Date.now();
    if (this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess.sdd) {
      this.setState({
        color: "green",
        text: "Hyperlocal Order",
      });
    } else {
      if (
        moment(
          this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess
            .orderDate
        ).format("DD-MM-YYYY") === moment(todayTimeStamp).format("DD-MM-YYYY")
      ) {
        this.setState({
          color: "yellow",
          text: "Today's Order",
        });
      } else {
        this.setState({
          color: "red",
          text: "Previous Day's Order",
        });
      }
    }
  };
  // componentDidUpdate() {
  //   setInterval(() => {
  //     const storedSelectedOption =
  //       JSON.parse(localStorage.getItem("userOnline")) || false;
  //     this.setState({ pickerOnline: storedSelectedOption });
  //   }, 500);
  // }

  updateBoxId = (value) => {
    this.setState({ showScannerScreen: false });
  };

  render() {
    const columns = [
      {
        title: "Medicine Name",
        dataIndex: "name",
        key: "name",
        render: (text) => {
          return {
            children: (
              <span style={{ color: "#000", fontWeight: 600 }}>{text}</span>
            ),
          };
        },
      },

      {
        title: "Reason",
        dataIndex: "reasonId",
        key: "reasonId",
        render: (text) => {
          return {
            children: (
              <span>
                {this.state.reasonMaster?.map((i) => {
                  if (Number(i.reasonId) === Number(text)) {
                    return i.value;
                  }
                })}
                {/* //* Replace this with reason key later */}
              </span>
            ),
          };
        },
      },
    ];
    if (!this.props.isOnline) {
      return <OfflinePage />;
    } else {
      return (
        <div className="centerScreen">
          {this.state.checkerNotification ? (
            <CheckerNotificationWrapper>
              <Result
                status="warning"
                title="Checker update received"
                className="checkerWarningMsg"
                extra={
                  <>
                    <p>
                      Order ID : <span>{this.state.currentOrderId}</span> picked
                      wrongly last time
                    </p>
                    <p>
                      Please pick box from{" "}
                      <b>{this.state.currentOrderData?.checkerName}</b>, Desk
                      No.
                      <b>{this.state.currentOrderData?.deskNumber}</b>
                    </p>
                  </>
                }
              />

              <Table
                dataSource={this.state.currentOrderData?.missingMedicineDetails}
                columns={columns}
                bordered
                loading={!this.state.currentOrderData}
                pagination={
                  this.state.currentOrderData?.missingMedicineDetails.length >
                  10
                }
                scroll={{ x: 400 }}
              />
              <br />

              {this.state.showScannerScreen && (
                <BarcodeScanner
                  scan={this.state.showScannerScreen ? true : false}
                  camera={this.state.showScannerScreen ? true : false}
                  redirect={"updateCheckerPick"}
                  orderId={this.state.currentOrderId}
                  history={this.props.history}
                  boxId={this.state.currentOrderData?.boxNumber}
                  getBoxId={this.updateBoxId}
                  boxUpdate={false}
                />
              )}
            </CheckerNotificationWrapper>
          ) : (
            <div>
              <div
                className=""
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                }}
              >
                {/* <Tag className="boxSection" color={this.state.color}>
                  <span>{this.state.text}</span>
                </Tag> */}
              </div>
              <OrderDetails
                orderId={this.state.currentOrderId}
                customerName={this.state.currentOrderData?.customerName}
                invoiceDate={this.state.currentOrderData?.invoiceDate}
                paymentType={this.state.currentOrderData?.paymentType}
                orderValue={this.state.currentOrderData?.orderValue}
                isLoading={this.state.serviceLoading}
                tagColor={this.state.color}
                tagText={this.state.text}
              />
              {this.state.showScannerScreen &&
              this.state.currentOrderData &&
              this.state.currentOrderData.boxNumber ? (
                <BarcodeScanner
                  scan={this.state.showScannerScreen ? true : false}
                  camera={this.state.showScannerScreen ? true : false}
                  redirect={"updateCheckerPick"}
                  orderId={this.state.currentOrderId}
                  history={this.props.history}
                  boxId={this.state.currentOrderData?.boxNumber}
                  tagColor={this.state.color}
                  tagText={this.state.text}
                  orderData={this.state.currentOrderData}
                  getBoxId={this.updateBoxId}
                  boxUpdate={false}
                />
              ) : (
                this.state.showScannerScreen && (
                  <BarcodeScanner
                    scan={this.state.showScannerScreen ? true : false}
                    camera={this.state.showScannerScreen ? true : false}
                    redirect={"picker"}
                    orderId={this.state.currentOrderId}
                    history={this.props.history}
                    getBoxId={this.updateBoxId}
                    boxUpdate={true}
                  />
                )
              )}
            </div>
          )}

          {/* //* Ideally here scanner opens fullscreen with camera & confirm button then user will redirect to next screen which has orderId & boxId in url encoded */}

          <button
            className="bbtn"
            disabled={this.state.serviceLoading}
            onClick={() => this.setState({ showScannerScreen: true })}
          >
            <AiOutlineScan /> Scan the barcode
          </button>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  pickerDetails: state.pickerorderReducer,
  onlineCheck:
    state.onlineStatusReducer?.isUserOnine?.response?.availableStatus?.value,
  newPickerDetails: state.newPickerOrderReducer,
  isOnline: state.statusReducer?.isOnline,
});

export default withRouter(
  connect(mapStateToProps, {
    pickerOrderDetailsThunk,
    getScannedPickerOrderDetailsThunk,
    // validateOrderAssignPickerThunk,
  })(PickerOrderProcess)
);
